// login Auth Varification API
export const AUTH_LOGIN = "auth/login"; 

//Notification API
export const GET_NOTIFICATION = "notification/getNotifications"

//Project Releted APIS
export const FATCH_CLIENT_PROJECTS = "projects/project_list_by_client?client_id="
export const FETCH_PROJECTS = 'projects/project_list?level=2'
export const PROJECT_DETAILS = "/project/"
export const PROJECT_DETAILS_PID=`projects/project_detail?pid=`
export const EDIT_PROJECT='projects/edit_project'
export const CREATE_NEW_PROJECT ='projects/new_project'
export const DELETE_PROJECT='projects/delete_project'
export const PROJECT_STATUS_CHANGE='projects/project_status_change'

//employee releted APIS
export const FETCH_EMPLOYEES_LIST="employees/employee_list"
export const EMPLOYEE_DETAILS = "/employee/"
export const ADD_EMPLOYEE='employees/add_employee'
export const DELETE_EMPLOYEE=`employees/delete_employee`
export const EDIT_EMPLOYEE = 'employees/edit_employee'
export const EMPLOYEE_DETAILS_EMPID="employees/employee_details?empid="

//client releted APIS
export const CLIENT_DETAILS = "/client/"
export const CLIENTS_DETAILS_LIST="clients/client_list"
export const ADD_CLIENT='clients/add_client'
export const EDIT_CLIENT ='clients/edit_client'
export const DELETE_CLIENT='clients/delete_client'
export const CLIENT_DETAILS_PID = "employees/employee_details?empid="

//reset password releted APIS
export const VALIDATE_RESET_TOKEN ='auth/validate_reset_token'
export const RESET_TO_NEW_PASSWORD ='auth/reset_to_new_password'

//budget releted APIS
export const NEW_BUDGET='budgets/new_budget'
export const BUDGET_STATUS='budgets/budget_status'
export const DELETE_BUDGET ='budgets/delete_budget'
export const ADD_NEW_BUDGET='budgets/new_budget'
export const EDIT_BUDGET='budgets/edit_budget'
export const BUDGET_LIST = 'budgets/budget_list?pid='

//task releted APIS
export const EDIT_TASK='tasks/edit_task'
export const DELETE_TASK ='tasks/delete_task'
export const ADD_TASK='tasks/add_task'

//permission releted api


export const ADD_PERMISSION = "permission/create_permission"
export const PERMISSION_LIST ="permission/list_permission"

//roles releted api 

export const  ROLE_LIST="roles/list_role"
export const ADD_NEW_USER_ROLE ="roles/add_role"


//forgot password releted apis

export const FORGOT_PASS_REQUEST = "/auth/forgot_password"
export const FORGOT_PASS_AUTH_TOKEN = "/auth/valid_otp"

export const FORGOT_PASS_CHANGE = "/auth/reset_password"


// task allocation to employee
export const TASK_EDIT_FOR_EMPLOYEE="allocations/edit_assign_task"
export const TASK_FOR_EMPLOYEE = "allocations/assign_task"
export const DELETE_TASK_ALLOCATION = "allocations/delete_assign_task"
export const MY_TASK_LIST = "allocations/my_tasks"
export const GET_ALL_EMP_TASK = "/allocations/tasks?emp_id="
export const GET_ALL_EMP_TIMESHEET = "timesheets/weekly_timesheets?emp_id="
export const GET_EACH_EMP_TIMESHEET = "timesheets/weekly_timesheet_records_emp?"

// timesheet releted apis 

export const EMP_TIME_LOG="timesheets/log_time"
export const EMP_WEEKLY_TIMESHEET = "timesheets/weekly_timesheets"
export const EMP_WEEK_RECORD="timesheets/weekly_timesheet_records?week_start="
export const SUBMIT_TIMESHEET="timesheets/submit_timesheet"
export const TIMESHEET_RECORD ="timesheets/record_time"
export const MY_PROFILE = "employees/profile"

export const ROLE_LIST_1 ="roles/list_role?level=1"
export const LIST_ALL_TIMESHEETS="/timesheets/list_all_timesheets"
export const REVIEW_TIMESHEET="/timesheets/review_timesheet"

//invoice related APIs
export const INVOICE_LIST = "invoices/invoice_list"
export const INVOICE_LIST_BY_PROJECT = "invoices/invoice_list_by_project"
export const NEW_INVOICE = "invoices/new_invoice"
export const INVOICE_DETAIL = "invoices/invoice_detail"
export const EDIT_INVOICE = "invoices/edit_invoice"
export const DELETE_INVOICE = "invoices/delete_invoice"

// documents / upload related APIs
export const DOCUMENT_UPLOAD = "documents/upload"
